// Simple pub/sub for toasts (no external deps)
const subscribers = new Set();

/** Internal: provider subscribes */
export function subscribeToast(handler) {
  subscribers.add(handler);
  return () => subscribers.delete(handler);
}

/** Public: show a toast (type: 'success' | 'info' | 'warning' | 'error') */
export function notify(type = "info", message = "", options = {}) {
  const payload = { variant: type, message, ...options }; // options: { position, duration }
  subscribers.forEach((fn) => fn(payload));
}

/** Public: convenience for centered toast */
export function notifyCenter(type = "info", message = "", options = {}) {
  notify(type, message, { ...options, position: "center" });
}
